import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import {computed} from 'vue';
import ISideMenuItem from "~/chat/vue/widget/sideMenu/ISideMenuItem";
import {ChatTabStore} from "~/chat/ts/store/ChatTab";
import {WidgetStore} from "~/chat/ts/store/Widget";
import {IWidgetTabParams, TAB_TYPE_CHAT, TAB_TYPE_REVIEWS} from "~/chat/ts/data/ITab";
import {ConfigStore} from "~/chat/ts/store/Config";
import {OperatorsStore} from "~/chat/ts/store/Operators";
import MessageStorage from "~/chat/ts/service/messages/MessageStorage";
import SideMenuItem from "~/chat/vue/widget/sideMenu/SideMenuItem.vue";
import MessageSender from "~/chat/ts/service/messages/MessageSender";
import {
    IMenuItem,
    TRIGGER_MENU_ITEM_TYPE_CHAT,
    TRIGGER_MENU_ITEM_TYPE_REVIEWS,
    TRIGGER_MENU_ITEM_TYPE_TAB
} from "~/chat/ts/data/ISiteParams";
import {__} from "~/ts/library/Translate";
import DateHelper from "~/ts/library/Date";
import Filters from "~/chat/ts/service/autoActions/Filters";
import ObjectHelper from "~/ts/library/ObjectHelper";


const __default__ = {
    name: "SideMenuList"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    exceptChat: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit

function selectTab(tab: IWidgetTabParams) {
    WidgetStore.openTab(tab);
    emits("close");
}


let items = computed(() => {
    let result: ISideMenuItem[] = [];
    let chatMode = ChatTabStore.chatTabMode.value;
    //let replaceChatTab = ConfigStore.replaceChatTab;
    let visibleMenuItems = ConfigStore.siteParams.value.params.siteChatOptions.widgetMenu.list.filter(item => {
        let result = true;//item.devices[ConfigStore.device.value] == 1;
        //if (result) {
        let tab: IWidgetTabParams | boolean = false;
        if (item.type == TRIGGER_MENU_ITEM_TYPE_CHAT) {
            if (props.exceptChat) {
                result = false;
            }
        } else if (item.type == TRIGGER_MENU_ITEM_TYPE_REVIEWS) {
            tab = WidgetStore.reviewsTab.value;
        } else if (item.type == TRIGGER_MENU_ITEM_TYPE_TAB) {
            tab = WidgetStore.visibleTabs.value.find(tab => tab.id == item.params.link);
        }
        if (tab !== false && !tab) {
            result = false;
        }
        if (result) {
            if (item.filters && ObjectHelper.hasKeys(item.filters)) {
                if (DateHelper.nowEverySecond) {
                    result = Filters.checkFilters(item.filters).isSuccess;
                }
            }
        }
        //}
        return result;
    });
    for (let menuItemConfig of visibleMenuItems) {
        ((menuItemConfig: IMenuItem) => {
            menuItemConfig = WidgetStore.modifyMenuItemAppearance(menuItemConfig);
            let item: ISideMenuItem = {
                title: menuItemConfig.descr,
                subTitle: menuItemConfig.subDescr,
                icon: menuItemConfig.iconName,
                iconColor: menuItemConfig.color1,
                iconStyle: menuItemConfig.iconStyle,
                originalMenuItem: menuItemConfig,
                onClick: () => {

                },
                children: []
            };

            let tab: IWidgetTabParams;
            if (menuItemConfig.type == TRIGGER_MENU_ITEM_TYPE_CHAT) {
                tab = WidgetStore.chatTab.value;
            } else if (menuItemConfig.type == TRIGGER_MENU_ITEM_TYPE_REVIEWS) {
                tab = WidgetStore.reviewsTab.value;
            } else if (menuItemConfig.type == TRIGGER_MENU_ITEM_TYPE_TAB) {
                tab = ConfigStore.tabsDictionary.value[menuItemConfig.params.link];
            }

            if (tab) {
                item.onClick = () => selectTab(tab);
                if (tab.type == TAB_TYPE_CHAT) {
                    if (OperatorsStore.isSelectAvailable.value && chatMode.allowSelectOperatorsInSideMenu && !MessageSender.isNeedToAskForOperator) {
                        item.children.push({
                            title: __("CHANGE_OPERATOR"),
                            icon: "users",
                            iconColor: tab.iconColor,
                            onClick: () => {
                                selectTab(tab);
                                ChatTabStore.showOperatorsSelect();
                            }
                        });
                    }
                    if (ConfigStore.siteParams.value.params.siteChatOptions.exportByClientAllowed && chatMode.allowExportDialog) {
                        if (MessageStorage.messageIdList.length) {
                            item.children.push({
                                title: __("SAVE_CHAT"),
                                icon: "envelope",
                                iconColor: tab.iconColor,
                                onClick: () => {
                                    selectTab(tab);
                                    ChatTabStore.SET_EXPORT_CHAT_DISPLAYED(true);
                                }
                            });
                        }
                    }
                } else if (tab.type == TAB_TYPE_REVIEWS) {
                    let params = ConfigStore.siteParams.value.params.rate;
                    let leaveReview: ISideMenuItem = {
                        title: params.leaveRateButtonText,
                        icon: "pencil",
                        iconColor: tab.iconColor,
                        onClick: () => {
                            WidgetStore.closeSideMenu();
                            WidgetStore.openSendReview();
                        }
                    };
                    if (menuItemConfig.params.content == "form") {
                        item.onClick = leaveReview.onClick;
                    } else if (params.loadInTab) {
                        item.children = [leaveReview];
                    }
                }
            }


            result.push(item);

        })(menuItemConfig);
    }
    return result;
});


return (_ctx: any,_cache: any) => {
  return (_unref(items).length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "before"),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item) => {
          return (_openBlock(), _createBlock(SideMenuItem, {
            key: item.id,
            item: item
          }, null, 8, ["item"]))
        }), 128)),
        _renderSlot(_ctx.$slots, "after")
      ]))
    : _createCommentVNode("", true)
}
}

})